import type { IRemoveTagCallingActionPayload } from 'entities/AICalling/api/types.ts'
import { removeTag } from 'widgets/TemplateActions/removeTag'
import { type AgentInstructionsStore } from 'pages/chatbot/pages/calling/ui/AICallingAgentManage/ui/AgentInstructions/store/AgentInstructionsStore.tsx'
import { createRemoveTagCallingAction } from './createRemoveTagCallingAction.ts'

export const onRemoveTagChipClick =
  (store: AgentInstructionsStore) => (chip: HTMLSpanElement, data: { token_id: string }) => {
    const { getAgentAction, onUpdateAgentAction, deleteChipAndAgentAction } = store
    let action: IRemoveTagCallingActionPayload | undefined

    if ('token_id' in data) {
      const token_id = data.token_id
      const findAction = getAgentAction(token_id)

      if (token_id) {
        if (findAction?.action_type === 'remove_tag') {
          action = findAction
        }
      }
    }
    if (action) {
      return removeTag({
        onSave: (data) =>
          onUpdateAgentAction(createRemoveTagCallingAction(data, action.settings.token_id)),
        onDelete: () => deleteChipAndAgentAction(chip, action),
        data: action.settings,
      })
    }
  }
